export var Langs;
(function (Langs) {
    Langs["fr"] = "fr";
    Langs["de"] = "de";
    Langs["en"] = "en";
    Langs["it"] = "it";
})(Langs || (Langs = {}));
/**
 * Get link to the `lang` version of the document or website. Uses fallback url if document or website is not available
 * for that lang.
 *
 * Main reason for this abstraction is to easily update strings when a new version of a document is available.
 *
 * **Example**:
 * German version of a document does not exist. You put in de.ts `getUrl(urls.docs.d01, DE)`. When that german url
 * becomes available, you define urls.docs.d01.de and all usages of `getUrl(urls.docs.d01, DE)` will point to the right
 * document without room for copy-pasting wrong/ctrl-f replace and missing.
 *
 * **Example2**:
 * Italian version of the website is not ready but the document is. You can already define the url.
 *
 * **Note**: other solution like interpolation ([doc](https://kazupon.github.io/vue-i18n/guide/formatting.html#named-formatting)
 * forces you to provide the actual link in the .vue file
 *
 * **Note2**: while fallback mechanism exists for internationalize strings, url are more "fragile" because documents might
 * not be ready
 *
 * @param url all version of the link to document or website with configured fallback url
 * @param lang url version to use for target language
 */
export function getUrl(url, lang) {
    var _a, _b, _c, _d;
    switch (lang) {
        case Langs.fr:
            return (_a = url.fr) !== null && _a !== void 0 ? _a : url.fallback;
        case Langs.de:
            return (_b = url.de) !== null && _b !== void 0 ? _b : url.fallback;
        case Langs.en:
            return (_c = url.en) !== null && _c !== void 0 ? _c : url.fallback;
        case Langs.it:
            return (_d = url.it) !== null && _d !== void 0 ? _d : url.fallback;
        default:
            return url.fallback;
    }
}
/**
 * All notables urls
 */
export var urls = {
    website: {
        institution: {
            fallback: "",
        }
    },
    docs: {
        d01: {
            fallback: "https://www.cinematheque.ch/film/reglement&tarifs_acces",
            fr: "https://www.cinematheque.ch/film/reglement&tarifs_acces",
            de: "https://www.cinematheque.ch/film/reglement&zugangstarife",
            en: "https://www.cinematheque.ch/film/rules&access_rates",
        },
        d02: {
            fallback: "https://www.cinematheque.ch/film/tarifs_consultation",
            fr: "https://www.cinematheque.ch/film/tarifs_consultation",
            de: "https://www.cinematheque.ch/film/tarife_einsichtnahme",
            en: "https://www.cinematheque.ch/film/consultation_rates",
        },
        d03: {
            fallback: "https://www.cinematheque.ch/cjs/conditions",
            fr: "https://www.cinematheque.ch/cjs/conditions",
            de: "https://www.cinematheque.ch/sfw/bedingungen",
            en: "https://www.cinematheque.ch/scj/terms",
        },
        d04: {
            fallback: "https://www.cinematheque.ch/non-film/reglement_utilisation",
            fr: "https://www.cinematheque.ch/non-film/reglement_utilisation",
            de: "https://www.cinematheque.ch/non-film/nutzungreglement",
            en: "https://www.cinematheque.ch/non-film/rules_of_use",
        },
        d05: {
            fallback: "https://www.cinematheque.ch/non-film/tarifs",
            fr: "https://www.cinematheque.ch/non-film/tarifs",
            de: "https://www.cinematheque.ch/non-film/tarife",
            en: "https://www.cinematheque.ch/non-film/rates",
        },
        d06: {
            fallback: "https://www.cinematheque.ch/non-film/copyright",
            fr: "https://www.cinematheque.ch/non-film/copyright",
            de: "https://www.cinematheque.ch/non-film/bildrechte",
            en: "https://www.cinematheque.ch/non-film/en/copyright",
        },
        d07: {
            fallback: "https://www.cinematheque.ch/deposants/tarifs",
            fr: "https://www.cinematheque.ch/deposants/tarifs",
            de: "https://www.cinematheque.ch/hinterleger/tarife",
            en: "https://www.cinematheque.ch/depositors/rates",
        },
        d08: {
            fallback: "https://www.cinematheque.ch/diffusion/tarifs",
            fr: "https://www.cinematheque.ch/diffusion/tarifs",
            de: "https://www.cinematheque.ch/vertrieb/tarife",
            en: "https://www.cinematheque.ch/distribution/rates",
        },
        d09: {
            fallback: "https://www.cinematheque.ch/dons&depots/politique_collection",
            fr: "https://www.cinematheque.ch/dons&depots/politique_collection",
            de: "https://www.cinematheque.ch/schenkung&hinterlegung/sammlungspolitik",
            en: "https://www.cinematheque.ch/donations&deposits/collection_policy",
        },
        d10: {
            fallback: "https://www.cinematheque.ch/dons&depots/depots_numeriques",
            fr: "https://www.cinematheque.ch/dons&depots/depots_numeriques",
            de: "https://www.cinematheque.ch/schenkung&hinterlegung/digitale_hinterlegungen",
            en: "https://www.cinematheque.ch/donations&deposits/digital_repositories",
        },
        d11: {
            fallback: "https://www.cinematheque.ch/ofc/confirmation_depot",
            fr: "https://www.cinematheque.ch/ofc/confirmation_depot",
            de: "https://www.cinematheque.ch/bak/hinterlegungsbestaetigung",
            en: "https://www.cinematheque.ch/foc/deposit_confirmation",
            it: "https://www.cinematheque.ch/ufc/conferma_deposito",
        },
        d12: {
            fallback: "https://www.cinematheque.ch/ofc/specifications_techniques",
            fr: "https://www.cinematheque.ch/ofc/specifications_techniques",
            de: "https://www.cinematheque.ch/bak/technische_vorschriften",
            en: "https://www.cinematheque.ch/foc/technical_specifications",
            it: "https://www.cinematheque.ch/ufc/specifiche_tecniche",
        },
        d13: {
            fallback: "https://www.cinematheque.ch/cjs/tarifs",
            fr: "https://www.cinematheque.ch/cjs/tarifs",
            de: "https://www.cinematheque.ch/sfw/tarife",
            en: "https://www.cinematheque.ch/scj/rates",
        },
        d14: {
            fallback: "https://www.cinematheque.ch/locations/conditions_generales",
            fr: "https://www.cinematheque.ch/locations/conditions_generales",
            de: "https://www.cinematheque.ch/vermietung/allgemeine_bedingungen",
            en: "https://www.cinematheque.ch/rental/general_conditions",
        },
    }
};
